var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductConfirmationSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#2F80ED",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.465 20.2352L27.84 14.9688C27.5828 14.8267 27.2938 14.7521 27 14.7521C26.7062 14.7521 26.4172 14.8267 26.16 14.9688L16.535 20.2373C16.2601 20.3877 16.0307 20.6092 15.8706 20.8785C15.7105 21.1479 15.6257 21.4553 15.625 21.7686V32.2292C15.6257 32.5425 15.7105 32.8499 15.8706 33.1193C16.0307 33.3886 16.2601 33.6101 16.535 33.7605L26.16 39.0291C26.4172 39.1712 26.7062 39.2457 27 39.2457C27.2938 39.2457 27.5828 39.1712 27.84 39.0291L37.465 33.7605C37.7399 33.6101 37.9693 33.3886 38.1294 33.1193C38.2895 32.8499 38.3743 32.5425 38.375 32.2292V21.7697C38.3749 21.4558 38.2903 21.1477 38.1302 20.8778C37.9701 20.6078 37.7404 20.3858 37.465 20.2352ZM27 16.5L35.7883 21.3125L32.5311 23.0942L23.7428 18.2817L27 16.5ZM27 26.125L18.2117 21.3125L21.9206 19.2814L30.7089 24.0939L27 26.125ZM36.625 32.2336L27.875 37.0231V27.6377L31.375 25.7225V29.625C31.375 29.8571 31.4672 30.0796 31.6313 30.2437C31.7954 30.4078 32.0179 30.5 32.25 30.5C32.4821 30.5 32.7046 30.4078 32.8687 30.2437C33.0328 30.0796 33.125 29.8571 33.125 29.625V24.7644L36.625 22.8492V32.2292V32.2336Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductConfirmationSvg);
export default __webpack_public_path__ + "static/media/product-confirmation-svg.5dd3d4a30c30ab85c22cf8e630a62547.svg";
export { ForwardRef as ReactComponent };